import React from "react";

export class ImpressumFR extends React.Component {
    render() {
        return (
            <>
                <p>DH Healthcare GmbH</p>
                <p>
                    Konrad-Zuse-Platz 1-3 <br />
                    53227 Bonn, Germany
                </p>
                <p>PDG: Davor Dadic</p>
                <p>
                    <br />
                    Téléphone : +32 52 77 01 15
                    <br />
                    Fax: +32 52 77 01 17
                    <br />
                    Email: info@dobcomed.com
                </p>

                <p>
                    <br />
                    Numéro TVA: BE0833277213
                </p>
                <p>RPM Gent, Division Termonde</p>
                <p>
                    <br />
                    Bank: ING
                    <br />
                    BE58 3630 8263 8279
                    <br />
                    BIC: BBRUBEBB
                </p>
            </>
        );
    }
}
